import type { GetTweets200PageAllOfThreeContentItemMediaLinksItemProjectInfoEngagementAllOf } from './getTweets200PageAllOfThreeContentItemMediaLinksItemProjectInfoEngagementAllOf';
import type { GetTweets200PageAllOfThreeContentItemMediaLinksItemProjectInfoEngagementAllOfTwo } from './getTweets200PageAllOfThreeContentItemMediaLinksItemProjectInfoEngagementAllOfTwo';

/**
 * 프로젝트 참여 통계
 */
export type GetTweets200PageAllOfThreeContentItemMediaLinksItemProjectInfoEngagement = GetTweets200PageAllOfThreeContentItemMediaLinksItemProjectInfoEngagementAllOf & GetTweets200PageAllOfThreeContentItemMediaLinksItemProjectInfoEngagementAllOfTwo;
